/* eslint-disable object-curly-newline */
import update from 'immutability-helper';
import naturalCompare from 'string-natural-compare';
import { indexById } from '../indexById/indexById';
import { get as getId } from '../localId/localId';

export const ADD_LOCAL_COST_CODE_CATEGORY = 'ADD_LOCAL_COST_CODE_CATEGORY';
export const REMOVE_LOCAL_COST_CODE_CATEGORY = 'REMOVE_LOCAL_COST_CODE_CATEGORY';
export const API_LOAD_COST_CODE_CATEGORIES = 'API_LOAD_COST_CODE_CATEGORIES';
export const API_REMOVE_COST_CODE_CATEGORY = 'API_REMOVE_COST_CODE_CATEGORY';
export const API_CREATE_COST_CODE_CATEGORY = 'API_CREATE_COST_CODE_CATEGORY';
export const API_UPDATE_COST_CODE_CATEGORY = 'API_UPDATE_COST_CODE_CATEGORY';

const API_LOAD_COST_CODE_CATEGORIES_FAILED = 'API_LOAD_COST_CODE_CATEGORIES_FAILED';
const API_LOAD_COST_CODE_CATEGORIES_LOADING = 'API_LOAD_COST_CODE_CATEGORIES_LOADING';
const API_LOAD_COST_CODE_CATEGORIES_LOADED = 'API_LOAD_COST_CODE_CATEGORIES_LOADED';
const API_REMOVE_COST_CODE_CATEGORY_FAILED = 'API_REMOVE_COST_CODE_CATEGORY_FAILED';
const API_REMOVE_COST_CODE_CATEGORY_LOADING = 'API_REMOVE_COST_CODE_CATEGORY_LOADING';
const API_REMOVE_COST_CODE_CATEGORY_SUCCESS = 'API_REMOVE_COST_CODE_CATEGORY_SUCCESS';
const API_CREATE_COST_CODE_CATEGORY_FAILED = 'API_CREATE_COST_CODE_CATEGORY_FAILED';
const API_CREATE_COST_CODE_CATEGORY_LOADING = 'API_CREATE_COST_CODE_CATEGORY_LOADING';
const API_CREATE_COST_CODE_CATEGORY_SUCCESS = 'API_CREATE_COST_CODE_CATEGORY_SUCCESS';
const API_UPDATE_COST_CODE_CATEGORY_FAILED = 'API_UPDATE_COST_CODE_CATEGORY_FAILED';
const API_UPDATE_COST_CODE_CATEGORY_LOADING = 'API_UPDATE_COST_CODE_CATEGORY_LOADING';
const API_UPDATE_COST_CODE_CATEGORY_SUCCESS = 'API_UPDATE_COST_CODE_CATEGORY_SUCCESS';

const defaultState = { costCodeCategories: [], loading: false };
const emptyCostCode = () => ({ id: getId(), name: '', isRemoving: false });
const mapDefaults = costCode => ({ ...emptyCostCode(), ...costCode });

export const reducer = (state = defaultState, { type, response, id, replaceId, resource }) => {
  switch (type) {
    case API_LOAD_COST_CODE_CATEGORIES_LOADED:
      return update(state, {
        loading: { $set: false },
        costCodeCategories: { $set: response.map(mapDefaults) },
      });
    case API_LOAD_COST_CODE_CATEGORIES_LOADING:
      return update(state, { loading: { $set: true } });
    case API_LOAD_COST_CODE_CATEGORIES_FAILED:
      return update(state, { loading: { $set: false } });
    case ADD_LOCAL_COST_CODE_CATEGORY:
      return update(state, { costCodeCategories: { $push: [emptyCostCode()] } });
    case API_REMOVE_COST_CODE_CATEGORY_SUCCESS:
    case REMOVE_LOCAL_COST_CODE_CATEGORY:
      return update(state, { costCodeCategories: { $splice: [[indexById(id, state.costCodeCategories), 1]] } });
    case API_REMOVE_COST_CODE_CATEGORY_FAILED:
      return update(state, { costCodeCategories: { [indexById(id, state.costCodeCategories)]: { removing: { $set: false } } } });
    case API_REMOVE_COST_CODE_CATEGORY_LOADING:
      return update(state, { costCodeCategories: { [indexById(id, state.costCodeCategories)]: { removing: { $set: true } } } });
    case API_CREATE_COST_CODE_CATEGORY_FAILED:
      return update(state, { costCodeCategories: { [indexById(resource.id, state.costCodeCategories)]: { saving: { $set: false } } } });
    case API_CREATE_COST_CODE_CATEGORY_LOADING:
      return update(state, { costCodeCategories: { [indexById(resource.id, state.costCodeCategories)]: { saving: { $set: true } } } });
    case API_CREATE_COST_CODE_CATEGORY_SUCCESS:
      return update(state, { costCodeCategories: { $splice: [[indexById(replaceId, state.costCodeCategories), 1, response]] } });
    default:
      return state;
  }
};

export const costCodeCategories = state => state.costCodeCategories.costCodeCategories.sort((a, b) => naturalCompare.caseInsensitive(a.name, b.name));
export const loading = state => state.costCodeCategories.loading;

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/costCodeCategory/costCodeCategory.reducer.js